
import ModalVideo from '~/components/globals/modal/video'
export default
	components: { ModalVideo }
	name: 'DefaultLayout'

